import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./SubmitLead.scss";

const SubmitLead = () => {
  const location = useLocation();
  const formRef = useRef(null);

  useEffect(() => {
    // Initialize form config
    const searchParams = new URLSearchParams(location.search);
    const click_id = searchParams.get("click_id") || "";

    // Initialize form config
    window._lg_form_init_ = { aid: "16319", template: "elvis-us", ref: "10", click_id: click_id };

    // Load the applicationInit script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://reservelead.com/form/applicationInit.js";

    script.onload = () => {
      console.log("Form script loaded successfully");
    };

    script.onerror = () => {
      console.error("Failed to load form script");
    };

    document.head.appendChild(script);

    // Cleanup khi unmount
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      // Clean up global config
      delete window._lg_form_init_;
    };
  }, [location.search]);

  return (
    <div className="submit-lead-page">
      {/* Header Banner */}
      <div className="submit-lead-header">
        <h2>You're almost done.</h2>
        <p>Please review and confirm these important details to complete your loan request.</p>
      </div>

      {/* Form container */}
      <div id="_lg_form_" ref={formRef}></div>
    </div>
  );
};

export default SubmitLead;
